import { tz } from '@date-fns/tz';
import { endOfDay, isFuture, parseISO } from 'date-fns';
import { Link } from 'react-router-dom';

import WarningBanner from 'common/WarningBanner';
import { useBoolean } from 'hooks';
import { formatDateDisplay, formatTime } from 'utils/datetime';

import DeleteReplacement from '../DeleteReplacement';
import { crewMemberInfoText } from '../text';

import styles from './styles.module.css';

const HoldDownWarning = ({ holdDown }) => {
	const [show, { setToTrue, setToFalse }] = useBoolean();

	if (!holdDown) return null;

	const { id, originalCrewMember, effectiveTimestamp, expireTimestamp } = holdDown;
	const replacementStartLabel = `${formatDateDisplay(effectiveTimestamp)} ${formatTime(effectiveTimestamp)}`;
	const replacementEndLabel = `${formatDateDisplay(expireTimestamp)} ${formatTime(expireTimestamp)}`;
	const canCancel = isFuture(endOfDay(parseISO(effectiveTimestamp), { in: tz('UTC') }));

	return (
		<>
			<WarningBanner>
				<p>
					{crewMemberInfoText.holdDownReplacingPrefix}
					<Link
						to={`/crew-management/${originalCrewMember.id}`}
						className={styles.profileLink}
						target="_blank"
						rel="noopener noreferrer"
					>
						{originalCrewMember.fullName}
					</Link>
					{crewMemberInfoText.holdDownReplacingFrom}
					<strong>
						{replacementStartLabel}
						{crewMemberInfoText.holdDownReplacingTo}
						{replacementEndLabel}.
					</strong>
				</p>
				{canCancel && (
					<button type="button" className={styles.cancelReplacement} onClick={setToTrue}>
						{crewMemberInfoText.cancelReplacement}
					</button>
				)}
			</WarningBanner>
			{show && <DeleteReplacement holdDownId={id} onClose={setToFalse} />}
		</>
	);
};

export default HoldDownWarning;
